var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserTransparentAlt = function SvgUserTransparentAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 19.75C20.0969 19.75 19.7688 19.6797 18.6156 20.0688C17.7953 20.3453 16.9141 20.5 16 20.5C15.0859 20.5 14.2047 20.3453 13.3844 20.0688C12.2312 19.6797 11.9078 19.75 10 19.75C6.68594 19.75 4 22.4359 4 25.75V26.5C4 27.3297 4.67031 28 5.5 28H26.5C27.3297 28 28 27.3297 28 26.5V25.75C28 22.4359 25.3141 19.75 22 19.75ZM25.75 25.75H6.25C6.25 24.7469 6.63906 23.8047 7.34688 23.0969C8.05469 22.3891 8.99688 22 10 22C11.9266 22 11.9219 21.9484 12.6625 22.1969C13.7406 22.5625 14.8656 22.75 16 22.75C17.1344 22.75 18.2594 22.5625 19.3375 22.1969C20.0781 21.9438 20.0734 22 22 22C24.0672 22 25.75 23.6828 25.75 25.75ZM16 19C20.1438 19 23.5 15.6438 23.5 11.5C23.5 7.35625 20.1438 4 16 4C11.8562 4 8.5 7.35625 8.5 11.5C8.5 15.6438 11.8562 19 16 19ZM16 6.25C18.8969 6.25 21.25 8.60313 21.25 11.5C21.25 14.3969 18.8969 16.75 16 16.75C13.1031 16.75 10.75 14.3969 10.75 11.5C10.75 8.60313 13.1031 6.25 16 6.25Z",
    fill: "#777777"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserTransparentAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-transparent-alt.c9790887.svg";
export { ForwardRef as ReactComponent };